var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55.4 55.4",
    enableBackground: "new 0 0 55.4 55.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sc_emblem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#11121C",
    d: "M27.6,0C12.3,0,0,12.5,0,27.8s12.5,27.7,27.8,27.6c15.3,0,27.6-12.4,27.6-27.7C55.4,12.4,43,0,27.6,0 C27.7,0,27.7,0,27.6,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.6,5.4C15.4,5.5,5.4,15.5,5.5,27.8C5.5,40.1,15.5,50,27.8,50C40.1,49.9,50,40,50,27.7 C50,15.4,40,5.4,27.6,5.4C27.7,5.4,27.7,5.4,27.6,5.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C82C5",
    d: "M29.8,25.1c-0.3-0.2-1.2-0.8-2.4-1.5c-2.4-1.5-5.7-3.6-6.8-4.5c-1.6-1.2-2.5-2.5-2.5-3.9 c0-0.6,0.1-1.3,0.4-1.8c-8,5.1-10.3,15.7-5.2,23.7C16.5,42,21.9,45,27.6,45c2.5,0,4.9-1,6.6-2.7c1.6-1.6,2.4-3.8,2.3-6.1 C36.6,30,30.5,25.6,29.8,25.1z M31.9,11.2c-1.4-0.3-2.8-0.3-4.1-0.1c-1.8,0.4-3.4,1.2-3.4,2.9s2.9,3.2,7.1,4.9 c6.3,2.6,12,6.9,13.2,11.1c0-0.4,0.1-0.7,0.1-1.1v-1C44.8,19.7,39.1,12.5,31.9,11.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C82C5",
    d: "M27.6,3.9c-13.3,0-24,10.7-24,24s10.7,24,24,24s24-10.7,24-24S40.9,3.9,27.6,3.9z M27.6,48.5 c-11.4,0-20.6-9.3-20.5-20.6S16.4,7.3,27.7,7.3c11.3,0,20.5,9.2,20.5,20.5C48.3,39.2,39.1,48.5,27.6,48.5 C27.7,48.5,27.7,48.5,27.6,48.5L27.6,48.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c6bc3b2ffb5a3615f21f3feb066a30f8.svg";
export { ForwardRef as ReactComponent };